"use client"
/* */
class BatchesController {
  batchSize;
  list;
  constructor(list, shape = {}) {
    const { batchSize = 20 } = shape;
    this.list = list;
    this.batchSize = batchSize;
    list.filters.forEach((f) => f.onFilterUpdated(() => this.reset()));
    list.search?.onUpdated(() => this.reset());
  }
  get reactTable() {
    return this.list.reactTable.table;
  }
  getBatchIndex() {
    return this.reactTable.getState().pagination.pageIndex;
  }
  hasNextBatch() {
    if (this.list.loader.manualPagination) {
      return this.reactTable.getCanNextPage();
    }
    return this.reactTable.getState().pagination.pageSize < this.getTotalItemsCount();
  }
  getTotalItemsCount() {
    if (this.list.loader.manualPagination) {
      return this.reactTable.getRowCount();
    }
    return this.reactTable.getFilteredRowModel().rows.length;
  }
  getVisibleItemsCount() {
    return this.reactTable.getRowModel().rows.length ?? 0;
  }
  updateItemTotalCount(value) {
    this.reactTable.setOptions((s) => ({
      ...s,
      rowCount: value
    }));
  }
  reset() {
    if (this.list.loader.manualFiltering) {
      this.updateItemTotalCount(0);
    }
    this.reactTable.setPagination(() => ({
      pageIndex: 0,
      pageSize: this.batchSize
    }));
  }
  nextBatch() {
    if (this.list.loader.manualPagination) {
      this.reactTable.nextPage();
    } else {
      const newSize = this.reactTable.getState().pagination.pageSize + this.batchSize;
      this.reactTable.setPagination((prev) => ({
        ...prev,
        pageSize: newSize
      }));
    }
  }
}

export { BatchesController };
//# sourceMappingURL=BatchesController.mjs.map
